export default [
    {
        path: '/accounting',
        meta: {
            title: "Accounting",
            icon: "accounting.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "accounting" */ '../views/admin/page/Accounting/Index'),
        redirect: { name: 'customerinvoice' },
        children: [
            {
                path: 'customerinvoice',
                name: 'customerinvoice',
                meta: {
                    title: "Customer Invoice",
                    show: true
                },
                component: () => import(/* webpackChunkName: "accounting" */'../views/admin/page/Accounting/CustomerInvoice'),
            },
            {
                path: 'customerinvoice/:id',
                name: 'customerinvoiceid',
                meta: {
                    title: "Customer Invoice Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "accounting" */'../views/admin/page/Accounting/CustomerInvoiceDetail'),
            },
            {
                path: 'customerinvoice/:id/:role',
                name: 'customerinvoicedetail',
                meta: {
                    title: "Customer Invoice Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "accounting" */'../views/admin/page/Accounting/CustomerInvoiceDetail'),
            },
            {
                path: 'dashboard',
                name: 'accounting.dashboard',
                meta: {
                    title: "Accounting Dashboard",
                    show: true
                },
                component: () => import(/* webpackChunkName: "accounting" */'../views/admin/page/Accounting/AccountingDashboard'),
            },
            {
                path: 'kasbon',
                name: 'kasbon',
                meta: {
                    title: "Kasbon Container",
                    show: true
                },
                component: () => import(/* webpackChunkName: "accounting" */'../views/admin/page/Accounting/CashAdvancePurchasingValidation'),
            },
        ]
    }
]